<template>
  <div class="form-errors" v-if="errors.length > 0">
    <p :key="index" v-for="(error, index) in errors" class="form-errors__entry" v-html="error"></p>
  </div>
</template>

<script src="./errors.js"></script>
<style src="./errors.scss" lang="scss"></style>
